<template>
  <CollapsableListItem class="item mb-2" @click.native="onClick" :class="{current: isCurrent}" :max-height="100">
    <template v-slot:header>
      <div><span class="font-weight-bold">Sent:</span> {{ formattedSent }}</div>
      <div><span class="font-weight-bold">Sender:</span> {{ emailAddressTextRepresentation }}</div>
      <div><span class="font-weight-bold">Recipient:</span> {{ contactTextRepresentation }}</div>
      <div><span class="font-weight-bold">Subject:</span> {{ subject }}</div>
    </template>
    <template v-slot:body>
      <div v-html="body"></div>
    </template>
  </CollapsableListItem>
</template>

<script>


import CollapsableListItem from "./collapsable-list-item.vue";
import {getTransformed} from "../../../../helpers";

export default {
  components: {CollapsableListItem},
  props: {
    item: null,
    isCurrent: null,
    select: null,
  },

  computed: {
    /**
     * @return {string}
     */
    subject() {
      return _.get(this.item, 'subject') || '';
    },

    /**
     * @return {string}
     */
    body() {
      return _.get(this.item, 'html_body') || '';
    },

    /**
     * @return {Object|null}
     */
    emailConversation() {
      return _.get(this.item, 'email_conversation', null);
    },

    /**
     * @return {Object|null}
     */
    message() {
      return _.get(this.item, 'message', null);
    },

    /**
     * @return {Object|null}
     */
    contact() {
      return _.get(this.emailConversation, 'contact', null);
    },

    /**
     * @return {Object|null}
     */
    emailAddress() {
      return _.get(this.emailConversation, 'email_address', null);
    },

    /**
     * @return {string}
     */
    emailAddressTextRepresentation() {
      return _.get(this.emailAddress, 'text_representation') || '';
    },

    /**
     * @return {string}
     */
    contactTextRepresentation() {
      return `${this.contact.full_name} (${this.contact.email})`;
    },

    /**
     * @return {string}
     */
    formattedSent() {
      return getTransformed(this.message, 'sent_at.datetime', value => {
        return moment(value).format(config('format.moment.short.datetime'));
      }, '');
    },
  },

  methods: {
    onClick() {
      this.select(this.item);
    }
  },
}
</script>
